import { Flex, Grid } from "@aws-amplify/ui-react";
import LocalizedStrings from "react-localization";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";

import PhoneInput from "./PhoneInput";

const PhoneList = ({ title, values, onChange }) => {
  const addInput = () => {
    onChange([...values, ""]);
  };

  const removeInput = (index) => {
    const listUpdated = [...values];
    listUpdated.splice(index, 1);
    onChange(listUpdated);
  };

  const onChangeInput = (index, value) => {
    const listUpdated = [...values];
    listUpdated[index] = value;
    onChange(listUpdated);
  };

  return (
    <>
      <Flex alignItems="center">
        <div className="fs-5">{title}</div>
        <div style={styles.iconAction} onClick={addInput}>
          <AddCircleOutline color="action" />
        </div>
      </Flex>
      {values?.length > 0 && (
        <Grid padding="10px">
          <Flex wrap="wrap" columnGap={30} rowGap={20}>
            {values?.map((item, index) => (
              <Flex key={index} alignItems="center">
                <PhoneInput
                  placeholder={strings.input.placeholder}
                  value={item}
                  onChange={(value) => onChangeInput(index, value)}
                />
                <div
                  style={styles.iconAction}
                  onClick={() => removeInput(index)}
                >
                  <RemoveCircleOutline color="action" />
                </div>
              </Flex>
            ))}
          </Flex>
        </Grid>
      )}
    </>
  );
};

const styles = {
  iconAction: {
    marginLeft: "-5px",
    cursor: "pointer",
  },
};

const strings = new LocalizedStrings({
  es: {
    input: {
      placeholder: "Ingrese teléfono",
    },
  },
});

export default PhoneList;
